import React from 'react';
import JavascriptExamples from './JavascriptExamples.jsx';
import JavascriptExamplesHtmlDom from './JavascriptExamplesHtmlDom.jsx';
import JavascriptExamplesHtmlInput from './JavascriptExamplesHtmlInput.jsx';
import JavascriptExamplesHtmlObjects from './JavascriptExamplesHtmlObjects.jsx';
import JavascriptExamplesHtmlEvents from './JavascriptExamplesHtmlEvents.jsx';
import JavascriptExamplesBrowser from './JavascriptExamplesBrowser.jsx';
import JavascriptExamplesEditor from './JavascriptExamplesEditor.jsx';
import JavascriptExamplesExercises from './JavascriptExamplesExercises.jsx';
import JavascriptExamplesQuiz from './JavascriptExamplesQuiz.jsx';
import JavascriptExamplesWebsite from './JavascriptExamplesWebsite.jsx';
import JavascriptExamplesSyllabus from './JavascriptExamplesSyllabus.jsx';
import JavascriptExamplesStudyPlan from './JavascriptExamplesStudyPlan.jsx';
import JavascriptExamplesInterviewPrep from './JavascriptExamplesInterviewPrep.jsx';
import JavascriptExamplesBootcamp from './JavascriptExamplesBootcamp.jsx';
import JavascriptExamplesCertificate from './JavascriptExamplesCertificate.jsx';

export default function JsExamples() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Examples</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/examples' className='underline'>JS Examples</a></li>
<li><a href='/javascript/examples/html-dom' className='underline'>JS HTML DOM</a></li>
<li><a href='/javascript/examples/html-input' className='underline'>JS HTML Input</a></li>
<li><a href='/javascript/examples/html-objects' className='underline'>JS HTML Objects</a></li>
<li><a href='/javascript/examples/html-events' className='underline'>JS HTML Events</a></li>
<li><a href='/javascript/examples/browser' className='underline'>JS Browser</a></li>
<li><a href='/javascript/examples/editor' className='underline'>JS Editor</a></li>
<li><a href='/javascript/examples/exercises' className='underline'>JS Exercises</a></li>
<li><a href='/javascript/examples/quiz' className='underline'>JS Quiz</a></li>
<li><a href='/javascript/examples/website' className='underline'>JS Website</a></li>
<li><a href='/javascript/examples/syllabus' className='underline'>JS Syllabus</a></li>
<li><a href='/javascript/examples/study-plan' className='underline'>JS Study Plan</a></li>
<li><a href='/javascript/examples/interview-prep' className='underline'>JS Interview Prep</a></li>
<li><a href='/javascript/examples/bootcamp' className='underline'>JS Bootcamp</a></li>
<li><a href='/javascript/examples/certificate' className='underline'>JS Certificate</a></li>
      </ul>
    </div>
  );
}
